
export const sumOfAmounts = (data, accountNumbers) =>
  data.filter((balance) => accountNumbers.includes(balance.accountNumber))
    .reduce((acc, { amount }) => acc + amount, 0);


export const sumOfBudgetAmounts = (budgetData, accountNumbers) =>
  budgetData
    .filter((budget) => accountNumbers.includes(budget.accountNumber))
    .reduce((acc, budget) => {
      const amount = budget.periods && budget.periods[0] ? budget.periods[0].amount : 0;
      return acc + amount;
    }, 0);

export const calculatePercentageChange = (oldValue, newValue) => {
    if (oldValue === 0 && newValue === 0) return 0;
    if (oldValue === 0) return 100;
    const difference = newValue - oldValue;
    return ((difference / Math.abs(oldValue)) * 100).toFixed(2);
  };

  export const getAmount = (data, accountNumber) => {
    if (!data) return null;
    const balance = data.find(balance => balance.accountNumber === accountNumber);
    return balance ? balance.amount : null;
};

export const getSumOfAccounts = (data, accountNumbers) => {
  return accountNumbers.reduce((sum, accountNumber) => {
    const amount = getAmount(data, accountNumber);
    return sum + (amount || 0);
  }, 0);
};

export const getSumOfBudgetAccounts = (budgetData, accountNumbers) => {
  if (!budgetData) return 0;
  return accountNumbers.reduce((sum, accountNumber) => {
      const budget = budgetData.find(budget => budget.accountNumber === accountNumber);
      if (budget && budget.periods && budget.periods[0]) {
          sum += budget.periods[0].amount;
      }
      return sum;
  }, 0);
};

export const getBudgetAmount = (data, accountNum) => {
  const accountData = data.find(budget => budget.accountNumber === accountNum);
  return accountData?.periods?.[0]?.amount || 0;
};